module.exports = __webpack_public_path__ + "img/COLUMN_TRANSPARENT_LEFT.6f719c15.svg";